<app-topo [dadosCertificado]="dadosCertificado" [dadosRegistro]="dadosRegistro"></app-topo>

<div class="container">
  <div class="row justify-content-md-center ">
    <div clas="col col-lg-8">
      <div class="card mb-3">
        <div class="card-header backgroundHeader text-center">
          Mensagem do Sistema
        </div>
        <div class="card-body backgroundBody text-left">
          <p class="card-text" *ngIf= "mensagemDirecionada === ''">
              {{ mensagemErro }}
          </p>
          <p class="card-text" *ngIf= "mensagemDirecionada != ''">
              <!--{{ mensagemDirecionada }}-->
              <span [innerHTML]="mensagemDirecionada"></span> 
          </p>
        </div>
      </div>
    </div>
  </div>
</div>